/**
 * Landmarks inside Rivo's account slideout (app embed).
 *
 * The header's account button opens Rivo's slideout (#rivo-account-slideout,
 * see assets/rivo-account-trigger.js). Its panel is a role="dialog", but the
 * <header> and <footer> inside it are not scoped to a sectioning element, so
 * they map to a second banner and a second contentinfo landmark while it is
 * open (axe landmark-no-duplicate-banner and -contentinfo, found by the
 * ONBRAND sweep on /cart, 2026-10-06). role="none" keeps their content and
 * drops only the landmark.
 *
 * Rivo renders the slideout into the page's HTML from its app embed, so one
 * pass after parsing reaches it; the hashchange pass covers a slideout Rivo
 * builds late. Rivo binds no role on these elements, so the edit sticks.
 * Remove this file with the app.
 */
(function () {
  'use strict';

  if (window.jiyuRivoA11y) return;
  window.jiyuRivoA11y = true;

  var SELECTOR = [
    '[id^="rivo"] [role="dialog"] header:not([role])',
    '[id^="rivo"] [role="dialog"] footer:not([role])',
  ].join(', ');

  function patch() {
    document.querySelectorAll(SELECTOR).forEach(function (el) {
      el.setAttribute('role', 'none');
    });
  }

  patch();
  window.addEventListener('hashchange', function () {
    setTimeout(patch, 0);
  });
})();
